import { STATUS } from "@/constants/statuses";
import { ReviewTranslationResponseEntity } from "@apps/reviews/entities/ReviewTranslationEntity";
import { EntityStore, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface ReviewsTranslationState {
    translations: ReviewTranslationResponseEntity[];
    pendingIds: number[];
    status: STATUS;
    isLocaleSupported: boolean;
    checkLocaleStatus: STATUS;
}

function createInitialState(): ReviewsTranslationState {
    return {
        translations: [],
        pendingIds: [],
        status: STATUS.VIRGIN,
        isLocaleSupported: false,
        checkLocaleStatus: STATUS.VIRGIN,
    };
}

@singleton()
@StoreConfig({ name: "ReviewsTranslationsStore" })
class ReviewsTranslationsStore extends EntityStore<ReviewsTranslationState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status: status,
        }));
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }

    setCheckLocaleStatus(status: STATUS) {
        this.update(() => ({
            checkLocaleStatus: status,
        }));
    }
    getCheckLocaleStatus(): STATUS {
        return this.getValue().checkLocaleStatus;
    }
}

export default ReviewsTranslationsStore;
